import { mapCurrency } from './mapCurrency'

import type { PurchaseOptions } from '@toni/commerce-api-types'

export const getLowestPrice = (primaryPurchaseOption?: PurchaseOptions[0], alternativePurchaseOptions?: PurchaseOptions): string => {
  if (!primaryPurchaseOption || !primaryPurchaseOption.price) {
    return ''
  }

  const alternativePurchaseOptionsLowestPrice = alternativePurchaseOptions?.filter(p => p.price.amount).reduce(
    (min, purchaseOption) => (purchaseOption.price.amount! < min! ? purchaseOption.price.amount : min),
    alternativePurchaseOptions[0]?.price.amount
  )
  return mapCurrency(
    alternativePurchaseOptionsLowestPrice,
    primaryPurchaseOption?.price.currency
  )
}
